import InvestmentDescriptions from "./InvestmentDescriptions"

export default InvestmentDescriptions
